import React, {useContext, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {TranslateContext} from "../../../context/TranslateContext";
import {getScadenzeApi} from "../services/HomeServices";
import DashboardScadenzeView from "./DashboardScadenzeView";
import {AuthContext} from "../../../context/AuthContext";

export default function DashboardScadenzeController() {

    const [loadingData, setLoadingData] = useState(true);
    const [scadenze, setScadenze] = useState([]);

    const {annoKpi} = useContext(AuthContext);
    const {translate} = useContext(TranslateContext);
    const history = useHistory();

    async function getScadenze() {
        const response = await getScadenzeApi();
        setScadenze(response.data.data);
        setLoadingData(false);
    }

    useEffect(() => {
        if (annoKpi) {
            getScadenze();
        }
    }, [annoKpi]);

    return (
        /* Disegno solo se sono presenti dati */
        !loadingData && scadenze &&
        <DashboardScadenzeView
            translate={translate}
            scadenze={scadenze}
            history={history}
        />
    );
}